/**
 * ResultList Component
 */

import { getResponsiveAssets } from '../../../../utils/image';
import { Size } from '../../../styles/sizes';
import './styles.scss';

import * as classNames from 'classnames';
import { chain, last, random } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { findDOMNode } from 'react-dom';
import { connect, DispatchProp } from 'react-redux';
import * as Velocity from 'velocity-animate';

import LoadingButton from '../../../molecules/buttons/LoadingButton';
import { ResultsPerPage } from '../../../pages/browse/Results';
import { baseline } from '../../../styles/grid';
import ResultListPage, { ResultListPageProps } from '../ResultListPage';

interface IOwnStateProps {
  hasValidLicense: boolean;
}

interface IOwnProps {
  className?: string;
  results: GQL.ITrackSearchResultEdge[];
  totalResults: number;
  onLoadMore(): any;
}

type IResultListProps = IOwnProps & IOwnStateProps & DispatchProp<any>;

interface IOwnState {
  isLoadingMoreResults: boolean;
}

const classes = new BEM('result-list');

class ResultList extends React.Component<IResultListProps, IOwnState> {
  private updateDisplayTimer: number;
  private element: HTMLDivElement;

  constructor(props) {
    super(props);

    this.state = {
      isLoadingMoreResults: false,
    };
  }

  componentDidMount() {
    this.element = findDOMNode(this) as HTMLDivElement;
  }

  componentDidUpdate(prevProps: IResultListProps, prevState: IOwnState) {
    // if (!prevProps.licenseBuilderIsVisible && this.props.licenseBuilderIsVisible) {
    //   this.updateDisplayTimer = window.setTimeout(() => {
    //     this.setState({ shouldDisplayResults: false });
    //   }, 1000);
    // } else if (prevProps.licenseBuilderIsVisible && !this.props.licenseBuilderIsVisible) {
    //   this.updateDisplayTimer = window.setTimeout(() => {
    //     this.setState({ shouldDisplayResults: true });
    //   }, 100);
    // }

    if (this.element) {
      const pages = this.element.getElementsByClassName('result-list-page');

      if (prevState.isLoadingMoreResults && this.state.isLoadingMoreResults) {
        this.setState({ isLoadingMoreResults: false }, () => {
          Velocity(last(pages), 'scroll', {
            offset: -(Size.pageWithHeaderMarginTop + Size.licenseBarHeight + baseline * 2),
            delay: 500,
            duration: 500,
          });
        });
      } else if (prevProps.results.length !== this.props.results.length) {
        window.scrollTo(0, 0);
      }
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.updateDisplayTimer);
  }

  onClickLoadMore = () => {
    this.setState({ isLoadingMoreResults: true });
  }

  renderPage(page: number, cardSize: CardSize) {
    const { results } = this.props;
    const resultListPageProps: ResultListPageProps = {
      gridSize: cardSize,
      pageNumber: page,
      results: results.slice(page * ResultsPerPage, (page + 1) * ResultsPerPage),
    };

    const collections =
      chain(resultListPageProps.results)
        .filter(({ node }) => !!node!.collections && !!node!.collections!.edges!.length)
        .map(({ node }) => node!.collections!.edges!.map((edge) => edge.node!))
        .flatten()
        .uniqBy('id')
        .value();

    if (collections.length && resultListPageProps.results!.length === ResultsPerPage) {
      const pickCollection = (c: GQL.ICollection[]): GQL.ICollection | undefined => {
        if (!c.length) {
          return undefined;
        }
        const index = random(0, c.length - 1);
        const collection = c[index];
        const assets = getResponsiveAssets('cover', collection.assets!);
        return !assets.blur
          ? pickCollection([...c].splice(index, 1))
          : collection;
      };
      resultListPageProps.collection = pickCollection(collections);
    }

    return (
      <ResultListPage
        key={`result-page-${page}-${resultListPageProps.results[0].node!.id}`}
        {...resultListPageProps}
      />
    );
  }

  render() {
    const {
      className,
      hasValidLicense,
      results,
      totalResults,
    } = this.props;

    const {
      isLoadingMoreResults,
    } = this.state;

    const cardSize = this.getGridSize();
    const nbOfPages = results.length / ResultsPerPage;
    const pages: number[] = [];
    for (let index = 0; index < nbOfPages; index++) {
      pages.push(index);
    }

    const classModifiers = {
      'with-license': hasValidLicense,
    };

    const extraClasses = classNames(className);

    return (
      <div {...classes('', classModifiers, extraClasses) }>
        <>
          {pages.map((page) => this.renderPage(page, cardSize))}
          {totalResults > results.length &&
            <LoadingButton
              label="Load More"
              onClick={this.onClickLoadMore}
              onLoad={this.props.onLoadMore}
              isLoading={isLoadingMoreResults}
              colorScheme="dark"
              size="large"
              variant="pill"
              {...classes('button-more') }
            />
          }
        </>
      </div>
    );
  }

  private getGridSize(): CardSize {
    const { totalResults } = this.props;
    return totalResults < 10 ?
      'xlarge'
      : 'small';
  }
}

const ConnectedResultList = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  ({ license }) => ({
    hasValidLicense: license.isValid,
  }),
)(ResultList);

export default ConnectedResultList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/ResultList/index.tsx